import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IEnrolledState, IFriendlyNamePayload } from '../../model/IMfa.model';
import { SharedService } from '../../shared.service';
import { TranslateService } from '@ngx-translate/core';

interface IFriendlyName{
  friendlyName: string;
}

@Component({
  selector: 'cid-friendly-name',
  templateUrl: './friendly-name.component.html',
  styleUrls: ['./friendly-name.component.scss'],
})
export class FriendlyNameComponent implements OnInit {
  @Input() enrolledStatus;
  @Input() method!: string;
  @Input() track_id!: string;

  @Output() enrolledState = new EventEmitter();

  // the flg is to handle the dynamic form flow
  isSubmitBtnClicked = false;

  form = {
    friendlyName: {
      fields: [
        {
          fieldKey: 'friendlyName',
          dataType: 'TEXT',
          required: true,
          enabled: true,
          fieldDefinition: {},
          localeText: {
            locale: 'en-us',
            language: 'en',
            name: this.translate.instant('SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.DISPLAY_NAME.LABEL'),
            placeholder: this.translate.instant('SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.DISPLAY_NAME.LABEL'),
            hint: this.translate.instant('SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.DISPLAY_NAME.HINT'),
          },
        },
      ],
      formOptions: {
        btnEnabled: false,
      },
      buttons: {
        cancel: {
          color: 'accent',
          text: 'SUGGESTED_VERIFICATION_METHOD.SKIP',
          alignment: 'right',
          type: 'proceed',
          underline: 'none',
          for: 'cidaasCancelBtn',
          translateArgs: {},
          style: 'secondary',
        },
        submit: {
          color: 'accent',
          text: 'SUGGESTED_VERIFICATION_METHOD.CONTINUE',
          alignment: 'right',
          type: 'proceed',
          underline: 'none',
          for: 'cidaasSubmitBtn',
          translateArgs: {},
        },
      },
      data: null,
    },
  };

  payload = <IFriendlyNamePayload>{};
  friendlyName: string = '';

  constructor(private _sharedService: SharedService, private translate:TranslateService) {}

  ngOnInit(): void {}

  /**
   *
   * @param e will hold the friendlyName
   * if e is not null then will assign it to the friendlyName variable
   */
  _setFriendlyName = (e: string) => {
    e ? (this.friendlyName = e) : null;
  };

  /**
   * will skip the friendlyName configuration process
   * will emit the process is completed
   */
  _skipFriendlyName = () => {
    const state = { status: 'completed', data: this.enrolledStatus };
    this.enrolledState.emit(state);
  };

  /**
   * Will save the friendlyName if anything is set
   * otherwise it will save the default name
   */
  _saveFriendlyName = (e:IFriendlyName) => {
    // constructing the payload for updating the friendlyName
    this.payload.device_id = this.enrolledStatus?.device_id;
    this.payload.friendly_name = e?.friendlyName;
    this.payload.id = this.enrolledStatus?.exchange_id?.exchange_id;
    this.payload.ph_id = this.enrolledStatus?.ph_id;
    this.payload.sub = this.enrolledStatus?.sub;

    // invoking the service method to save the friendlyName
    this._sharedService._saveFriendlyName(this.payload, this.track_id, this.method).subscribe(
      (res) => {
        if (res && res?.success) {
          const state: IEnrolledState = { status: 'completed', data: this.enrolledStatus };
          this.enrolledState.emit(state);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };
}
